import { reactive } from 'vue';

const state = reactive({
  lastContact: null, // { type: 'contact' | 'company', entityid: string }
});

export default function useTempSettings() {
  function setLastContact(type, entityid) {
    if (!type || !entityid) {
      state.lastContact = null;
      return;
    }

    state.lastContact = {
      type,
      entityid,
    };
  }

  function getLastContact() {
    return state.lastContact;
  }

  function clearLastContact() {
    state.lastContact = null;
  }

  return {
    lastContact: state.lastContact,
    setLastContact,
    getLastContact,
    clearLastContact,
  };
}
